(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icewave-model-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.iwReady === 'true') return;
      root.dataset.iwReady = 'true';
      const cards = [...root.querySelectorAll('[data-model]')];
      root.querySelectorAll('[data-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.filter;
          root.querySelectorAll('[data-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
          cards.forEach((card) => {
            card.classList.toggle('is-match', filter !== 'all' && card.dataset.model === filter);
            card.classList.toggle('is-muted', filter !== 'all' && card.dataset.model !== filter);
          });
          if (filter !== 'all') cards.find((card) => card.dataset.model === filter)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      const table = root.querySelector('.iw-compare__table');
      const activateModel = (model) => {
        if (!table) return;
        table.dataset.mobileModel = model;
        table.querySelectorAll('[data-product]').forEach((cell) => cell.classList.toggle('is-mobile-active', cell.dataset.product === model));
        root.querySelectorAll('[data-mobile-model]').forEach((item) => item.classList.toggle('is-active', item.dataset.mobileModel === model));
      };
      root.querySelectorAll('[data-mobile-model]').forEach((button) => button.addEventListener('click', () => activateModel(button.dataset.mobileModel)));
      activateModel(table?.dataset.mobileModel);
    };
    document.querySelectorAll('[data-iw-compare]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-iw-compare]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
